import clsx from 'clsx';
import React from 'react';
import { getAlertClassName, getAlertIconName } from '../../objects';
import { has, is } from '../../services/classify';
import { Icon, IconName } from '../icon';
import { Text } from '../text';
import { Title, TitleLevels } from '../title';
import { hashClass } from '../../helpers';
import { useTrilogyContext } from '../../context';
/**
 * Alert Component
 * @param iconName {IconName} Custom icon
 * @param title {string} Alert title content
 * @param description {string|ReactNode} Alertt description content
 * @param alert {AlertState} Alert Variant (INFO|SUCCESS|WARNING|ERROR)
 * @param onClick {Function} onClick Event for all alert
 * @param className {string} Additionnal CSS Classes
 * @param iconClassname {string} Additionnal Icon CSS
 * @param display
 * @param others
 */
const Alert = ({ alert, className, iconClassname, iconName, title, description, onClick, display, testId, ...others }) => {
    const { styled } = useTrilogyContext();
    const classes = hashClass(styled, clsx('alert', has('body'), alert && is(getAlertClassName(alert)), className));
    const iconAlert = React.useMemo(() => {
        var _a;
        if (iconName != null)
            return iconName;
        else if (alert)
            return (_a = getAlertIconName(alert)) !== null && _a !== void 0 ? _a : IconName.INFOS_CIRCLE;
        else
            return IconName.INFOS_CIRCLE;
    }, [iconName, alert]);
    if (display) {
        return (React.createElement("div", { "data-testid": testId, onClick: (e) => {
                // eslint-disable-next-line no-unused-expressions
                onClick === null || onClick === void 0 ? void 0 : onClick(e);
                e.stopPropagation();
            }, className: classes, ...others },
            React.createElement(Icon, { className: iconClassname, name: iconAlert }),
            React.createElement("div", { className: hashClass(styled, clsx('body')) },
                title && typeof title.valueOf() === 'string' ? React.createElement(Title, { level: TitleLevels.THREE }, title) : title,
                description && typeof description.valueOf() === 'string' ? React.createElement(Text, null, description) : description)));
    }
    return React.createElement("div", null);
};
export default Alert;
//# sourceMappingURL=Alert.js.map